import { Marketing } from "./Marketing";

export default Marketing;
